"use client";

import { Prose } from "../../../prose/prose";
import { CosmosText, CosmosTitle } from "@cosmos/web-react";
import classNames from "classnames/bind";
import Head from "next/head";
import styles from "./QaArticle.module.css";

const cx = classNames.bind(styles);

export const QaArticle = ({
  title,
  categoryTitle,
  content,
  contentHtml,
}: {
  title: string | null;
  categoryTitle: string | null;
  content: React.ReactNode;
  contentHtml: string | null;
}) => {
  return (
    <>
      {contentHtml && (
        <Head>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org/",
                "@type": "FAQPage",
                mainEntity: [
                  {
                    "@type": "Question",
                    name: title,
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: contentHtml,
                    },
                  },
                ],
              }),
            }}
          />
        </Head>
      )}
      <div className={cx("container")}>
        <div className={cx("inner")}>
          <div className={cx("main")}>
            {/* TODO: look at this h3/h2 hierarchy */}
            <h3 className={cx("category-title-wrapper")}>
              <CosmosTitle
                className={cx("category-title-prefix")}
                tag="span"
                size="xx-small"
              >
                {"Q&A "}
              </CosmosTitle>
              <CosmosText
                tag="span"
                className={cx("category-title")}
                size="small"
              >
                {categoryTitle}
              </CosmosText>
            </h3>
            <CosmosTitle tag="h2" className={cx("title")} size="x-large">
              {title}
            </CosmosTitle>
            <Prose className={cx("prose")}>{content}</Prose>
          </div>
        </div>
      </div>
    </>
  );
};
